module.exports = __webpack_public_path__ + "static/media/hotel-9.07962269.jpg";